import React, { Component } from 'react';
//显示中文字体
import {Button, ConfigProvider, Modal} from 'antd';
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn'
import zh_CN from 'antd/locale/zh_CN';
import './App.css';
import {Provider} from 'react-redux';//引入react-redux
import  store from './store/index';
import AppRouter from './AppRouter'
import {ErrorBoundary, FallbackProps} from "react-error-boundary";
import {closeWebSocket, createWebSocket} from "./components/webSocket/WebSocketCpt";
import {HashRouter} from 'react-router-dom'
import {SerialPort} from './components/SerialCpt/SerialCpt';
import AppService from "./AppService";
import parent from "./api/parent";
const router = new HashRouter();
dayjs.locale('zh-cn');
function ErrorFallback({error, resetErrorBoundary}: FallbackProps) {
    return(
        <div role='alert'>
            <p>加载失败：</p>
            <pre>{error.message}</pre>
            <button onClick={resetErrorBoundary}>再试一次</button>
        </div>
    )
}
let audioSrc = 'https://zhegtao-chain-dealer.oss-cn-qingdao.aliyuncs.com/voice/new_work_leads.mp3';
class App extends Component {
    audioBtn = React.createRef();
    constructor() {
        super();
        window.home = this;
        this.state = {
            showVersion: false
        }
    }
    componentDidMount() {
        const currentUserInfo = JSON.parse(localStorage.getItem('currentUserAllInfo') || '{}')
        const id = currentUserInfo.dealerCode;
        if (!id) {
            // 这里可以等待用户信息写入后再初始化 WebSocket
            // 比如监听登录/初始化完成事件;
            router.history.push('/Login');
            return;
        }
        try {
            // createWebSocket();
        } catch (error) {
            console.error("失败:", error);
        }
    }
    componentWillUnmount() {
        // closeWebSocket();
    }
    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        this.checkNativeVersion();
    }

    playFun = () => {
        this.audioBtn.current.click();
    }
    checkNativeVersion = () => {
        AppService.getVersion({
            appName: 'storenative'
        }).then(res => {
            if (res.code === '1000') {
                let nativeVersion = res.data.versionNumber;
                window.electronAPI.getVersion().then(data => {
                    if (nativeVersion !== data) {
                        this.setState({
                            showVersion: true
                        })
                    } else {
                        this.checkVersion();
                    }
                })
            }
        })
    }
    checkVersion = () => {
        AppService.getVersion({
            appName: 'store'
        }).then(res => {
            if (res.code === '1000') {
                let version = res.data.versionNumber;
                if (parent.pcVersion !== version) {
                    window.electronAPI.requestRefresh();
                }
            }
        })
    }
  render() {
    return (
        <Provider store={store}>
          <ConfigProvider locale={zh_CN}>
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                  <div style={{display: 'none'}}>
                      <audio id="sing">
                          <source src={audioSrc}/>
                      </audio>
                      <Button onClick={() => {
                          let sing = document.getElementById("sing");
                          sing.play();
                      }} ref={this.audioBtn}>播放</Button>
                  </div>
                    <AppRouter/>
                  <Modal
                      open={this.state.showVersion}
                      title="版本检测"
                      onOk={null}
                      onCancel={null}
                      maskClosable={false}
                      footer={[
                          <Button
                              key="link"
                              target="_blank"
                              type="primary"
                              onClick={() => {
                                  let time = new Date().getTime();
                                  // window.electronAPI.openWithChrome('http://8.148.178.235/downloadNative.html?time=' + time);
                                  //生产环境
                                  window.electronAPI.openWithChrome('https://www.baikezd.com/downloadNative.html?time=' + time);
                              }}
                          >
                              去安装
                          </Button>,
                      ]}
                  >
                      <p>检测到有新的版本，请安装最新版本</p>
                  </Modal>
              </ErrorBoundary>
          </ConfigProvider>
        </Provider>
    );
  }
}

export default App;

